// extracted by mini-css-extract-plugin
export default {"container":"_63a98634f902b0e5","header":"_42882aa30d0c8262","body":"c524cbfb54fc7f68","select":"_3811cbdb252859f9"};